var map = {
	"./arrow-left.svg": "QxKr",
	"./arrow-right.svg": "VlFc",
	"./award.svg": "zRYk",
	"./bookmark.svg": "XBAF",
	"./chevron-down-alt.svg": "w48D",
	"./chevron-down.svg": "M34q",
	"./lock.svg": "IMRB",
	"./logo-primary.svg": "KVl0",
	"./logo-secondary.svg": "NDNw",
	"./star.svg": "zz8J",
	"./stomach-sleeper.svg": "S3ci",
	"./truck.svg": "3hsi"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+PVQ";